import React from 'react';
import ReactDOM from 'react-dom';

class Ostatni extends React.Component {
    render() {
        const showNewsletter = window.showNewsletterInput;
        const { store } = this.props;
        let nastup = new Date(store.prvniNastupniTerminKurzu());
        let date = new Date();
        date.setDate(date.getDate() + 28);
        return (
            <div style={{paddingTop: 15, marginTop: 15, borderTop: "solid 1px #fff"}}>
                <h2 style={{maxWidth: 254}}>{ window.texts && window.texts.h_ostatni_sluzby ? window.texts.h_ostatni_sluzby : 'Objednávám tyto služby.'}</h2>
                <div className="formRow">
                    <label>Letištní transfer:</label> 
                    <div className="checkbox">
                        <input type="radio" name={`prihlaska[vyzvednuti]`} 
                            id={`prihlaska-vyzvednuti-Yes`} value="Yes" 
                            checked={this.state.vyzvednuti === "Yes"} 
                            onChange={(e) => {this.setState({vyzvednuti: "Yes"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-vyzvednuti-Yes`}>Ano</label>


                        <input type="radio" name={`prihlaska[vyzvednuti]`} 
                            id={`prihlaska-vyzvednuti-No`} value="No" 
                            checked={this.state.vyzvednuti === "No"}
                            onChange={(e) => {this.setState({vyzvednuti: "No"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-vyzvednuti-No`} style={{marginRight: 15}}>Ne</label>
                        
                        {this.state.vyzvednuti === "Yes" &&
                            <select value={this.state.vyzvednutiTyp} name="prihlaska[vyzvednuti_typ]" onChange={(e) => {this.setState({vyzvednutiTyp: e.target.value})}}>
                                <option>Při příjezdu i odjezdu</option>
                                <option>Při příjezdu</option>
                            </select>
                        }
                    </div>
                </div>

                <div className="formRow">
                    <label>Cestovní pojištění Allianz:</label> 
                    <div className="checkbox">
                        <input type="radio" name={`prihlaska[pojisteni]`} 
                            id={`prihlaska-pojisteni-Yes`} value="Yes" 
                            checked={this.state.pojisteni === "Yes"} 
                            onChange={(e) => {this.setState({pojisteni: "Yes"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-pojisteni-Yes`}>Ano</label>


                        <input type="radio" name={`prihlaska[pojisteni]`} 
                            id={`prihlaska-pojisteni-No`} value="No" 
                            checked={this.state.pojisteni === "No"}
                            onChange={(e) => {this.setState({pojisteni: "No"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-pojisteni-No`}>Ne</label>
                    </div>
                </div>
                <div className="formRow" style={{ minHeight: 37 }}>
                    <label>Pojištění stornovacích poplatků Allianz:</label> 
                    <div className="checkbox">
                        <input type="radio" name={`prihlaska[pojisteni_storno]`} 
                            id={`prihlaska-pojisteni-storno-Yes`} value="Yes" 
                            checked={this.state.pojisteniStorno === "Yes"} 
                            onChange={(e) => {this.setState({pojisteniStorno: "Yes"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-pojisteni-storno-Yes`}>Ano</label>


                        <input type="radio" name={`prihlaska[pojisteni_storno]`} 
                            id={`prihlaska-pojisteni-storno-No`} value="No" 
                            checked={this.state.pojisteniStorno === "No"}
                            onChange={(e) => {this.setState({pojisteniStorno: "No"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-pojisteni-storno-No`}>Ne</label>
                    </div>
                </div>
                <div className="formRow">
                    <label>Letenka:</label> 
                    <div className="checkbox">
                        <input type="radio" name={`prihlaska[letenka]`} 
                            id={`prihlaska-letenka-Yes`} value="Yes" 
                            checked={this.state.letenka === "Yes"} 
                            onChange={(e) => {this.setState({letenka: "Yes"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-letenka-Yes`}>Ano</label>


                        <input type="radio" name={`prihlaska[letenka]`} 
                            id={`prihlaska-letenka-No`} value="No" 
                            checked={this.state.letenka === "No"}
                            onChange={(e) => {this.setState({letenka: "No"})}}
                            required={true}
                            />

                        <label htmlFor={`prihlaska-letenka-No`}>Ne</label>
                    </div>
                </div>

                {nastup > date && window.showPaymentOption === true &&
                    <div className="formRow">
                        <label>Způsob úhrady pobytu:</label> 
                        <div className="checkbox">
                            <input type="radio" name={`prihlaska[zpusob_uhrady]`} 
                                id={`prihlaska-zpusob-uhrady-cely`} value="Celý pobyt" 
                                checked={this.state.zpusobUhrady === "Celý pobyt"} 
                                onChange={(e) => {this.setState({zpusobUhrady: "Celý pobyt"})}}
                                required={true}
                                />

                            <label htmlFor={`prihlaska-zpusob-uhrady-cely`}>Celý pobyt</label>


                            <input type="radio" name={`prihlaska[zpusob_uhrady]`} 
                                id={`prihlaska-zpusob-uhrady-zaloha`} value="Zálohou" 
                                checked={this.state.zpusobUhrady === "Zálohou"}
                                onChange={(e) => {this.setState({zpusobUhrady: "Zálohou"})}}
                                required={true}
                                />

                            <label htmlFor={`prihlaska-zpusob-uhrady-zaloha`}>Zálohou</label>
                        </div>
                    </div>
                }

                {showNewsletter && (
                  <div className="formRow">
                      <label>Zasílání novinek STUDYLINE:</label>
                      <div className="checkbox">
                          <input type="radio" name={`prihlaska[newsletter]`}
                                 id={`prihlaska-newsletter-Yes`} value="Yes"
                                 checked={this.state.newsletter === "Yes"}
                                 onChange={(e) => {this.setState({newsletter: "Yes"})}}
                                 required={true}
                          />

                          <label htmlFor={`prihlaska-newsletter-Yes`}>Ano</label>


                          <input type="radio" name={`prihlaska[newsletter]`}
                                 id={`prihlaska-newsletter-No`} value="No"
                                 checked={this.state.newsletter === "No"}
                                 onChange={(e) => {this.setState({newsletter: "No"})}}
                                 required={true}
                          />

                          <label htmlFor={`prihlaska-newsletter-No`}>Ne</label>
                      </div>
                  </div>
                )}


                {window.showWorkgroup && (
                  <div className="formRow" style={{paddingTop: 15, marginTop: 15, borderTop: "solid 1px #fff"}}>
                      <label>Pobočka Studyline:</label>
                      <select id="kurz" name="prihlaska[pobocka]" onChange={(e) => {this.setState({pobocka: e.target.value})}} value={this.state.pobocka}>
                          <option value="1">Praha - V Jámě 1</option>
                          <option value="6">Brno - Křenová 52</option>
                      </select>
                  </div>
                )}
                <div className="formRow" style={{paddingTop: 15, marginTop: 15, borderTop: "solid 1px #fff"}}>
                    <label>Poznámky:</label> 
                    <textarea name="prihlaska[poznamky]" rows="5" cols="45" style={{width: "auto"}} onChange={(e) => {this.setState({poznamky: e.target.value})}} value={this.state.poznamky}></textarea>
                </div>

            </div>
        );
    }

    constructor(props) {
        super(props);
        let loadedData = props.store.loadedData;
        this.state = {
            vyzvednuti: loadedData["prihlaska[vyzvednuti]"] ? loadedData["prihlaska[vyzvednuti]"] : 0,
            vyzvednutiTyp: loadedData["prihlaska[vyzvednuti_typ]"] ? loadedData["prihlaska[vyzvednuti_typ]"] : "Yes",
            pojisteni: loadedData["prihlaska[pojisteni]"] ? loadedData["prihlaska[pojisteni]"] : 0,
            pojisteniStorno: loadedData["prihlaska[pojisteni_storno]"] ? loadedData["prihlaska[pojisteni_storno]"] : 0,
            zpusobUhrady: loadedData["prihlaska[zpusob_uhrady]"] ? loadedData["prihlaska[zpusob_uhrady]"] : 0,
            letenka: loadedData["prihlaska[letenka]"] ? loadedData["prihlaska[letenka]"] : 0,
            newsletter: loadedData["prihlaska[newsletter]"] ? loadedData["prihlaska[newsletter]"] : 0,
            poznamky: loadedData["prihlaska[poznamky]"] ? loadedData["prihlaska[poznamky]"] : ""
        }
    }
}

export default Ostatni;


// WEBPACK FOOTER //
// ./resources/prihlaska/ostatni.js